"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _decorators = require("../../decorators");
var _cssUtils = require("../../utils/css-utils");
var _domUtils = require("../../utils/dom-utils");
var _class, _ResponsiveFontSizeComponent; //helpers
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ResponsiveFontSizeComponent = (0, _decorators.styleable)(_class = (_ResponsiveFontSizeComponent = /*#__PURE__*/function (_Component) {
  function ResponsiveFontSizeComponent() {
    var _this;
    _classCallCheck(this, ResponsiveFontSizeComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResponsiveFontSizeComponent, [].concat(args));
    _defineProperty(_this, "handleResize", function (style) {
      for (var prop in style) {
        _this.ref.style[prop] = "".concat(style[prop], "px");
      }
    });
    return _this;
  }
  _inherits(ResponsiveFontSizeComponent, _Component);
  return _createClass(ResponsiveFontSizeComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        baseWidth = _this$props.baseWidth,
        minFontSize = _this$props.minFontSize,
        minPadding = _this$props.minPadding,
        _this$props$onResize = _this$props.onResize,
        onResize = _this$props$onResize === void 0 ? this.handleResize : _this$props$onResize;
      var clientWidth = this.ref.clientWidth;
      var multiplier = Math.max(1, clientWidth / baseWidth);
      var padding = (0, _cssUtils.unpackCssShorthand)(minPadding).map(function (padding) {
        return Math.round(padding * multiplier);
      });
      onResize({
        fontSize: Math.round(minFontSize * multiplier),
        paddingTop: padding[0],
        paddingRight: padding[1],
        paddingBottom: padding[2],
        paddingLeft: padding[3]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        children = _this$props2.children,
        dangerouslySetInnerHTML = _this$props2.dangerouslySetInnerHTML;
      if (children) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          children: children,
          ref: function ref(_ref) {
            return _this2.ref = _ref;
          }
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        ref: function ref(_ref2) {
          return _this2.ref = _ref2;
        }
      });
    }
  }]);
}(_react.Component), _defineProperty(_ResponsiveFontSizeComponent, "defaultProps", {
  baseWidth: 0,
  minFontSize: (0, _domUtils.rem)(1),
  minPadding: 0
}), _defineProperty(_ResponsiveFontSizeComponent, "propTypes", {
  // Lowest width for the the font size and padding to start growing:
  baseWidth: _propTypes["default"].number,
  // Starting font size:
  minFontSize: _propTypes["default"].number,
  // Starting padding
  minPadding: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].number), _propTypes["default"].number]),
  // A function to be called with the computed fontSize/padding
  // combination. When not provided, applies the styles on itself
  onResize: _propTypes["default"].func
}), _ResponsiveFontSizeComponent)) || _class;
var _default = exports["default"] = ResponsiveFontSizeComponent;
//# sourceMappingURL=index.js.map